module.exports = __webpack_public_path__ + "static/share-data-d58a36687104e137bc849f5cfb098036.png";